import 'zone.js';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { environment } from './environments/environment';
import { ChildSaleModule } from './child-sale/child-sale.module';

if (environment.production && !environment.prodEnabled) {
  enableProdMode();
  environment.prodEnabled = true;
}

platformBrowserDynamic().bootstrapModule(ChildSaleModule)
  .catch((err) => console.error(err));
